// extracted by mini-css-extract-plugin
export var background = "request-landing-module--background--PBOsQ";
export var bookRequest = "request-landing-module--bookRequest--DmpiA";
export var collectionRequest = "request-landing-module--collectionRequest--1UCN0";
export var floating = "request-landing-module--floating--t91RL";
export var formInstructions = "request-landing-module--formInstructions--+Wdhg";
export var formSelect = "request-landing-module--formSelect--AFGdl";
export var landing = "request-landing-module--landing--cXVcu";
export var selectedForm = "request-landing-module--selectedForm--XtfIJ";
export var unselectedForm = "request-landing-module--unselectedForm--cryNw";